import React, { Component } from 'react';

class BrandInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props.brandinfo;
        return (
            <div className="brand-info"
                style={{ color: props.textColor, backgroundColor: props.backgroundColor }}>
                <figure className=" brand-info__figure" dangerouslySetInnerHTML={{ __html: props.brandImageUrl }} />
                <div className="brand-info__text-container">
                    <div className="brand-info__content">
                        <hgroup className="brand-info__hgroup">
                            {props.pageTitle && <h2 className="brand-info__pre-title pre-header-list">
                                {props.pageTitle}
                            </h2>
                            }
                            {props.title && <h3 className="brand-info__title header-list">
                                {props.title}
                            </h3>
                            }
                        </hgroup>
                        <div className="brand-info__text"
                            dangerouslySetInnerHTML={{ __html: props.text.value }}>
                        </div>
                    </div>
                    {props.brandUrl &&
                        <div className="brand-info__logo-container">
                            <a
                                href={props.brandUrl}
                                dangerouslySetInnerHTML={{ __html: props.logoUrl }} />
                        </div>
                    }
                </div>
            </div>


        );

    }
}

export default BrandInfo;
